import type { LogEntry } from './loggerTypes'
import { mapLogEntryToOtelFormat } from './otelLogMapper'
import { getOtelLogger, forceFlushOtel } from './otelBootstrap'

export { forceFlushOtel }

export function emitOtelLog(entry: LogEntry) {
  const logger = getOtelLogger()
  if (!logger) return

  try {
    const otelLogRecord = mapLogEntryToOtelFormat(entry)
    // Map OTel attributes format properly for `logger.emit`
    // Ensure `attributes` are mostly primitives or arrays for OTel standard compliance.
    logger.emit(otelLogRecord as import('@opentelemetry/api-logs').LogRecord)
  } catch (error) {
    // Failsafe so logging doesn't crash the app
    console.warn('[Logger] Failed to emit OTel log:', error)
  }
}
